module.exports = __webpack_public_path__ + "img/智慧环卫综合管理平台V1.0.a7b22b7c.jpg";